import BugReportPage from "./pages/BugReportPage";

export { BugReportPage };

export const bugReportRoutes = [
  {
    path: "/bug-report",
    element: <BugReportPage />,
  },
];
